// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"122":"f00572bd","989":"ea173141"}[chunkId] + ".chunk.css";
};